const appInfo = {
    title: 'TAMBAQ',
    logo: 'logo.png',
    bgLogin: './background/bg.jpg'
};
export default appInfo;